import { hasAllowedLicence } from '../data/allowedLicenses';

// The credits table's rows (CreditsAndLicensesScreen) from Iconify's list of icon sets
// (GET https://api.iconify.design/collections: each set's prefix → its metadata, the
// IconifyInfo type of @iconify/types): the sets under one of the allowed licences, each
// with its name, author and licence as the answer gives them, sorted by name. The two
// guards for forms the type excludes (a set without a licence, inside hasAllowedLicence,
// and one without an author, which the screen names as unknown) stay: the answer is
// Iconify's to change; none of its 276 sets lacked either on 2 Nov 2026.
export const iconSetCredits = (collections) =>
  Object.entries(collections)
    .filter(([, info]) => hasAllowedLicence(info))
    .map(([prefix, info]) => ({
      prefix,
      name: info.name,
      author: info.author ?? null, // covers a set without an author, which the type doesn't allow
      license: info.license,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
